import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import InputField from '../../components/inputFields/InputField';
import { patchCommunity, postCommunity } from '../../services/community';
import { patchCbbo, postCbbo } from '../../services/fpo';

function FpoCbboForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rowData, setRowData] = useState(null);

    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("name", values.name);

        try {
            const response = rowData ? await patchCbbo({ data: formData, id: rowData.id }) : await postCbbo({ data: formData });

            if (response?.status === 200 || response.status === 201) {
                toast.success(rowData ? "CBBO updated successfully" : "CBBO added successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
        }
    }, [location]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Enquiries' },
            { name: "FPOs", link: (-1) },
            { name: rowData ? "Edit CBBO" : "Add CBBO" },
        ]} />
        <div className="mt-8">
            <Formik
                initialValues={rowData || {
                    name: "",
                }}
                validationSchema={Yup.object({
                    name: Yup.string().required("Title is required"),
                })}
                enableReinitialize
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, resetForm }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-3 mb-3">
                                    <InputField
                                        label="Name"
                                        name="name"
                                        type="text"
                                        placeholder="CBBO name"
                                        required
                                    />
                                </div>

                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Saving..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default FpoCbboForm;